export const DATE_ASC = "dateAsc";
export const DATE_DESC = "dateDesc";
export const TOTAL_DESC = "totalDesc";
export const TOTAL_ASC = "totalAsc";
export const SPREAD_DESC = "spreadDesc";
export const SPREAD_ASC = "spreadAsc";
export const MARGIN_DESC = "marginDesc";
export const MARGIN_ASC = "marginAsc";
